import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { NavigationItemMenu } from '@cbridge-tools/navigation-item';
import { INavigationItemContextMenuProps } from './NavigationItemContextMenu.interface';

export const NavigationItemContextMenu: FunctionComponent<INavigationItemContextMenuProps> = (props) => {
  const { onEdit, onDelete } = props;

  const { t } = useTranslation();

  return (
    <NavigationItemMenu>
      <MenuItem onClick={onEdit}>
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        <ListItemText>
          {t('text:common.button.edit')}
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        <ListItemText>
          {t('text:common.button.delete')}
        </ListItemText>
      </MenuItem>
    </NavigationItemMenu>
  );
};
